import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

import { AbstractStatSiteTracking } from 'src/services/tracking/abstract/abstract-stat-site-tracking';

interface IInteractionStatSiteEventData {
    eventName: string;
    value: object;
}

@Injectable({ providedIn: 'root' })
export class InteractionStatSiteTrackingService extends AbstractStatSiteTracking {
    private readonly platformId = inject(PLATFORM_ID);

    private readonly group = 'interactions';

    constructor() {
        const httpClient = inject(HttpClient);

        super(httpClient);
    }

    public track(data: IInteractionStatSiteEventData, requestOrigin: string): void {
        if (isPlatformBrowser(this.platformId)) {
            this.transport(
                {
                    event: data.eventName,
                    group: this.group,
                    path: this.getPathname(),
                    value: data.value,
                },
                requestOrigin
            ).subscribe();
        }
    }
}
